<template>
    <v-parallax dark src="@/assets/images/vbanner.jpg">
        <v-row align="center" justify="center">
            <v-col class="text-center" cols="12">
                <h1 class="display-1 font-weight-thin mb-4">KHIPU</h1>
                <v-list-item-avatar color="blue darken-2" size="180">
                    <v-icon size="160">person</v-icon>
                </v-list-item-avatar>
                <h2 class="display-1 font-weight-thin mb-4">INICIO</h2>
                <!-- <div id="google-signin-button" style="display: flex; align-items: center; justify-content: center;"></div> -->
                <v-dialog v-model="dModal.dialog" max-width="300px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" v-bind="attrs" v-on="on" class="mt-2"><v-icon left>vpn_key</v-icon> Ingreso con Usuario</v-btn>
                    </template>
                    <v-card class="elevation-12">
                        <v-card-title class="primary"><span class="headline">Ingresar</span></v-card-title>
                        <v-card-text class="p-0 pt-3">
                            <v-form ref="refModal">
                                <v-text-field v-model="dUser" prepend-icon="person" label="Login" type="text" :rules="[v => !!v || 'El campo es requerido']"></v-text-field>
                                <v-text-field v-model="dPsw" prepend-icon="lock" label="Password" type="password" :rules="[v => !!v || 'El campo es requerido']"></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuLogin2" :loading="dLoading" class="primary" dark><v-icon left>vpn_key</v-icon> Ingresar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog><br/>
                <v-progress-circular :size="70" :width="7" :indeterminate="dLoading" v-if="dLoading"></v-progress-circular>
            </v-col>
        </v-row>
    </v-parallax>
</template>
<script>
import gql from 'graphql-tag';
import {mapActions} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    mounted() {
        gapi.signin2.render("google-signin-button", {
            onsuccess: this.onSignIn,
        });
    },
    data: () => ({
        dUser: '',
        dPsw: '',
        dLoading: false,
        dModal: {
            dialog: false,
            editedIndex: -1,
            IsUpdating: false,
        },
    }),
    methods: {
        ...mapActions(['saLogin', 'saLogout']),
        onSignIn(googleUser) {
            var profile = googleUser.getBasicProfile();
            this.fuLogin(profile.getEmail().split('@')[0]);

            // console.log("ID: " + profile.getId()); // Do not send to your backend! Use an ID token instead.
            // console.log("Name: " + profile.getName());
            // console.log("Image URL: " + profile.getImageUrl());
            // console.log("Email: " + profile.getEmail()); // This is null if the 'email' scope is not present.
        },
        async fuLogin(pUser){
            try {
                this.dLoading = true;
                const response = await this.$apollo.query({
                    query: gql`query pripersonalByUsuario($Usuario: String!){
                        pripersonalByUsuario(Usuario:$Usuario){
                            IdPersonal
                            Usuario
                            Personal
                            IdKhipuPlus
                        }
                    }`,
                    variables: {
                        Usuario: pUser
                    }
                })
                if(!response.data.pripersonalByUsuario){
                    Swal.fire('¡ ERROR !', 'No existe usuario.', 'error');
                    this.saLogout();
                } else {
                    localStorage.setItem('ssUser', JSON.stringify(response.data.pripersonalByUsuario));
                    this.saLogin(response.data.pripersonalByUsuario);
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error en la conexión.', 'error');
                this.saLogout();
            } finally {
                this.dLoading = false;
            }
        },
        fuLogin2(){
            if(this.$refs.refModal.validate())
                this.fuLoginQuery();
        },
        async fuLoginQuery(){
            try {
                this.dLoading = true;
                const response = await this.$apollo.query({
                    query: gql`query pripersonalByUsuarioByIngresoS($Usuario: String!, $IngresoS: String!){
                        pripersonalByUsuarioByIngresoS(Usuario:$Usuario, IngresoS:$IngresoS){
                            IdPersonal
                            Usuario
                            Personal
                            IdKhipuPlus
                        }
                    }`,
                    variables: {
                        Usuario: this.dUser,
                        IngresoS: this.dPsw
                    }
                })
                if(!response.data.pripersonalByUsuarioByIngresoS){
                    Swal.fire('¡ ERROR !', 'No existe usuario.', 'error');
                } else {
                    localStorage.setItem('ssUser', JSON.stringify(response.data.pripersonalByUsuarioByIngresoS));
                    this.saLogin(response.data.pripersonalByUsuarioByIngresoS);
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error en la conexión.', 'error');
                this.saLogout();
            } finally {
                this.dLoading = false;
            }
        }
    },
};
</script>
